/* eslint-disable */
import { TextPosition, TextSearchResults, HelperMethods } from '../index';
import { beforeXmlHttpRequestSend } from './../../index';
import { Dictionary } from '../../base/dictionary';
import { TextElementBox, ErrorTextElementBox, TableCellWidget, FieldElementBox, ParagraphWidget, TableWidget, ShapeElementBox, GroupShapeElementBox, FootnoteElementBox, BookmarkElementBox } from '../viewer/page';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * The spell checker module
 */
var SpellChecker = /** @class */ (function () {
    function SpellChecker(documentHelper) {
        this.langIDInternal = 0;
        /**
         * Specifies whether spell check has to be performed or not.
         */
        this.enableSpellCheckInternal = true;
        /**
         * @private
         */
        /* eslint-disable @typescript-eslint/no-explicit-any */
        this.uniqueSpelledWords = {};
        /**
         * Every time rendering text elementbox we are checking the key length of the uniqueSpelledWords object. This causes performance issue So optimizing it.
         */
        this.uniqueSpelledWordsCount = 0;
        this.spellSuggestionInternal = true;
        /**
         * @private
         */
        this.uniqueKey = '';
        this.removeUnderlineInternal = false;
        this.combinedElements = [];
        /**
         * @default 1000
         */
        this.uniqueWordsCountInternal = 15000;
        this.performOptimizedCheck = true;
        /**
         * @private
         */
        this.handleErrorElements = [];
        /**
         * @private
         */
        this.isChangeAll = false;
        /**
         * @private
         */
        this.skipChangeDetection = false;
        this.pageCacheIndex = [];
        this.ignoreUppercaseInternal = false;
        this.enableUserDictionaryInternal = false;
        this.documentHelper = documentHelper;
        this.errorWordCollection = new Dictionary();
        this.uniqueWordsCollection = new Dictionary();
        this.errorSuggestions = new Dictionary();
        this.ignoreAllItems = [];
        this.uniqueSpelledWords = {};
        if (!isNullOrUndefined(this.documentHelper) && !isNullOrUndefined(this.documentHelper.owner)) {
            this.textSearchResults = new TextSearchResults(this.documentHelper.owner);
            this.uniqueKey = this.documentHelper.owner.element.id + '_' + this.createGuid();
        }
    }
    Object.defineProperty(SpellChecker.prototype, "ignoreUppercase", {
        /**
         * Gets a value indicating whether to ignore words written in uppercase during spell check.
         *
         * @aspType bool
         * @returns {boolean} Returns ignoreUppercase
         */
        get: function () {
            return this.ignoreUppercaseInternal;
        },
        /**
         * Sets a value indicating whether to ignore words written in uppercase during spell check.
         *
         * @aspType bool
         */
        set: function (value) {
            this.ignoreUppercaseInternal = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpellChecker.prototype, "enableUserDictionary", {
        /**
         * Gets the boolean indicating whether user-specific dictionaries are enabled.
         *
         * If true, maintains a user-specific custom dictionary file for spell checking.
         * If false, maintains a common custom dictionary for all users.
         *
         * @aspType bool
         * @returns {boolean} Returns enableUserDictionary
         */
        get: function () {
            return this.enableUserDictionaryInternal;
        },
        /**
         * Sets the boolean indicating whether user-specific dictionaries are enabled.
         *
         * If true, maintains a user-specific custom dictionary file for spell checking.
         * If false, maintains a common custom dictionary for all users.
         *
         * @aspType bool
         */
        set: function (value) {
            this.enableUserDictionaryInternal = value;
            // Reset spell checker collections when switching users with user dictionary enabled
            // because spelling errors need to be re-evaluated based on the user's specific or custom dictionary
            this.documentHelper.triggerSpellCheck = true;
            this.resetSpellCheckState();
            this.viewer.updateScrollBars();
            this.documentHelper.triggerSpellCheck = false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets module name.
     */
    SpellChecker.prototype.getModuleName = function () {
        return 'SpellChecker';
    };
    Object.defineProperty(SpellChecker.prototype, "enableOptimizedSpellCheck", {
        /**
         * Gets the boolean indicating whether optimized spell check to be performed.
         *
         * @aspType bool
         * @returns {boolean} Returns enableOptimizedSpellCheck
         */
        get: function () {
            return this.performOptimizedCheck;
        },
        /**
         * Sets the boolean indicating whether optimized spell check to be performed.
         *
         * @aspType bool
         */
        set: function (value) {
            this.performOptimizedCheck = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpellChecker.prototype, "uniqueWordsCount", {
        /**
         * Gets the spell checked Unique words.
         *
         * @aspType int
         */
        get: function () {
            return isNullOrUndefined(this.uniqueWordsCountInternal) ? 0 : this.uniqueWordsCountInternal;
        },
        /**
         * Sets the spell checked Unique words.
         *
         * @aspType int
         */
        set: function (value) {
            this.uniqueWordsCountInternal = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpellChecker.prototype, "languageID", {
        /**
         * Gets the languageID.
         *
         * @aspType int
         */
        get: function () {
            return isNullOrUndefined(this.langIDInternal) ? 0 : this.langIDInternal;
        },
        /**
         * Sets the languageID.
         *
         * @aspType int
         */
        set: function (value) {
            this.langIDInternal = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpellChecker.prototype, "allowSpellCheckAndSuggestion", {
        /**
         * Getter indicates whether suggestion enabled.
         *
         * @aspType bool
         */
        get: function () {
            return this.spellSuggestionInternal;
        },
        /**
         * Setter to enable or disable suggestion
         *
         * @aspType bool
         */
        set: function (value) {
            this.spellSuggestionInternal = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpellChecker.prototype, "removeUnderline", {
        /**
         * Getter indicates whether underline removed for mis-spelled word.
         *
         * @aspType bool
         */
        get: function () {
            return this.removeUnderlineInternal;
        },
        /**
         * Setter to enable or disable underline for mis-spelled word
         *
         * @aspType bool
         */
        set: function (value) {
            this.documentHelper.triggerElementsOnLoading = true;
            this.documentHelper.triggerSpellCheck = true;
            this.removeUnderlineInternal = value;
            this.documentHelper.owner.editorModule.reLayout(this.documentHelper.selection);
            this.documentHelper.triggerElementsOnLoading = false;
            this.documentHelper.triggerSpellCheck = false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpellChecker.prototype, "enableSpellCheck", {
        /**
         * Getter indicates whether spell check has to be performed or not.
         *
         * @aspType bool
         */
        get: function () {
            return this.enableSpellCheckInternal;
        },
        /**
         * Setter to enable or disable spell check has to be performed or not
         *
         * @aspType bool
         */
        set: function (value) {
            this.enableSpellCheckInternal = value;
            this.documentHelper.owner.editorModule.reLayout(this.documentHelper.selection);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpellChecker.prototype, "viewer", {
        get: function () {
            return this.documentHelper.owner.viewer;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Method to manage replace logic
     *
     * @private
     */
    SpellChecker.prototype.manageReplace = function (content, dialogElement, isChangeAll) {
        this.documentHelper.triggerSpellCheck = true;
        var exactText = '';
        var elementInfo;
        if (!isNullOrUndefined(dialogElement) && dialogElement instanceof ErrorTextElementBox) {
            var exactText_1 = dialogElement.text;
            var isInHeaderFooter = dialogElement.start.currentWidget.paragraph.isInHeaderFooter;
            if (isInHeaderFooter) {
                var paragraphInfo = this.documentHelper.selection.getParagraphInfo(dialogElement.start);
                var endParagraphInfo = this.documentHelper.selection.getParagraphInfo(dialogElement.end);
                var startIndex = this.documentHelper.selection.getHierarchicalIndex(paragraphInfo.paragraph, paragraphInfo.offset.toString());
                var endIndex = this.documentHelper.selection.getHierarchicalIndex(endParagraphInfo.paragraph, endParagraphInfo.offset.toString());
                this.documentHelper.selection.start = this.documentHelper.selection.getTextPosBasedOnLogicalIndex(startIndex);
                this.documentHelper.selection.end = this.documentHelper.selection.getTextPosBasedOnLogicalIndex(endIndex);
            }
            else {
                this.documentHelper.selection.start = dialogElement.start.clone();
                this.documentHelper.selection.end = dialogElement.end.clone();
            }
            if (content !== 'Ignore Once') {
                if (this.documentHelper.selection.start.paragraph.isFieldCodeBlock) {
                    return;
                }
                content = this.manageSpecialCharacters(exactText_1, content);
                this.addRemovedElements(isChangeAll, dialogElement);
                this.documentHelper.owner.editorModule.insertTextInternal(content, true);
                this.documentHelper.selection.start.setPositionInternal(this.documentHelper.selection.end);
                this.documentHelper.clearSelectionHighlight();
                return;
            }
            else {
                this.currentContextInfo = { 'text': exactText_1, 'element': dialogElement };
            }
        }
        if (!isNullOrUndefined(this.currentContextInfo) && this.currentContextInfo.element instanceof ErrorTextElementBox && content !== 'Ignore Once') {
            var elementBox = this.currentContextInfo.element;
            exactText = this.currentContextInfo.element.text;
            this.documentHelper.selection.start = elementBox.start.clone();
            this.documentHelper.selection.end = elementBox.end.clone();
        }
        else {
            this.handleReplace(content);
        }
        if (content !== 'Ignore Once') {
            this.addRemovedElements(isChangeAll, dialogElement);
            this.documentHelper.owner.editorModule.insertTextInternal(content, true);
            if (isChangeAll && !isNullOrUndefined(this.currentContextInfo)) {
                this.removeErrorsFromCollection(this.currentContextInfo);
            }
            this.documentHelper.selection.start.setPositionInternal(this.documentHelper.selection.end);
            this.documentHelper.clearSelectionHighlight();
        }
        //this.documentHelper.owner.errorWordCollection.remove(content);
        this.documentHelper.triggerSpellCheck = false;
    };
    SpellChecker.prototype.addRemovedElements = function (isChangeAll, dialogElement) {
        if (!isChangeAll) {
            if (this.handleErrorElements.indexOf(dialogElement) === -1) {
                this.handleErrorElements.push(dialogElement);
            }
            var start = this.documentHelper.selection.start;
            var end = this.documentHelper.selection.end;
            if (!this.documentHelper.selection.isForward) {
                start = this.documentHelper.selection.end;
                end = this.documentHelper.selection.start;
            }
            var startElement = start.currentWidget.getInline(start.offset, 0, false, true).element;
            var endElement = end.currentWidget.getInline(end.offset, 0, false, true).element;
            while (true) {
                if (this.handleErrorElements.indexOf(startElement) === -1) {
                    this.handleErrorElements.push(startElement);
                }
                if (startElement === endElement) {
                    break;
                }
                startElement = startElement.nextNode;
            }
        }
    };
    /**
     * Method to handle replace logic
     *
     * @private
     */
    SpellChecker.prototype.handleReplace = function (content) {
        var startPosition = this.documentHelper.selection.start;
        var offset = startPosition.offset;
        var startIndex = 0;
        var startInlineObj = startPosition.currentWidget.getInline(offset, startIndex, false, true);
        var startOffset = startInlineObj.element.line.getOffset(startInlineObj.element, 0) + startInlineObj.element.length;
        if (startOffset === offset) {
            this.retrieveExactElementInfo(startInlineObj);
        }
        var exactText = startInlineObj.element.text;
        var startPattern = new RegExp('^[#\\@\\!\\~\\$\\%\\^\\&\\*\\(\\)\\-\\_\\+\\=\\{\\}\\[\\]\\:\\;\\"\'\\,\\<\\.\\>\\/\\?\\`\\s]+', 'g');
        var matches = [];
        var matchInfo;
        // eslint-disable  no-cond-assign
        while (!isNullOrUndefined(matchInfo = startPattern.exec(exactText))) {
            matches.push(matchInfo);
        }
        if (content === 'Ignore Once') {
            this.handleIgnoreOnce(startInlineObj);
            return;
        }
        startPosition.offset = offset - startInlineObj.index;
        if (!isNullOrUndefined(matches) && matches.length > 0) {
            startPosition.offset += matches[0].toString().length;
        }
        startPosition.location = this.documentHelper.owner.selectionModule.getPhysicalPositionInternal(startPosition.currentWidget, startPosition.offset, true);
        startPosition = this.documentHelper.owner.searchModule.textSearch.getTextPosition(startPosition.currentWidget, startPosition.offset.toString());
        //startPosition.location = this.owner.selection.getPhysicalPositionInternal(span.line, offset, true);
        startPosition.setPositionParagraph(startPosition.currentWidget, startPosition.offset);
        var index = (startPosition.offset + startInlineObj.element.length) - startPosition.offset;
        var endOffset = startPosition.currentWidget.getOffset(startInlineObj.element, index);
        var lineWidget = startPosition.currentWidget;
        var endPattern = new RegExp('[#\\@\\!\\~\\$\\%\\^\\&\\*\\(\\)\\-\\_\\+\\=\\{\\}\\[\\]\\:\\;\\"\'\\,\\<\\.\\>\\/\\?\\s\\`]+$', 'g');
        matches = [];
        // eslint-disable  no-cond-assign
        while (!isNullOrUndefined(matchInfo = endPattern.exec(exactText))) {
            matches.push(matchInfo);
        }
        if (!isNullOrUndefined(matches) && matches.length > 0) {
            endOffset -= matches[0].toString().length;
        }
        this.documentHelper.selection.end = this.documentHelper.owner.searchModule.textSearch.getTextPosition(lineWidget, endOffset.toString());
        this.documentHelper.selection.end.location = this.documentHelper.owner.selectionModule.getPhysicalPositionInternal(startPosition.currentWidget, endOffset, true);
        this.documentHelper.selection.end.setPositionParagraph(lineWidget, endOffset);
        this.currentContextInfo = { 'element': startInlineObj.element, 'text': startInlineObj.element.text };
    };
    /**
     * Method to retrieve exact element info
     *
     * @private
     */
    SpellChecker.prototype.retrieveExactElementInfo = function (startInlineObj) {
        var nextElement = startInlineObj.element.nextElement;
        if (!isNullOrUndefined(nextElement) && nextElement instanceof TextElementBox) {
            var nextTextElBox = nextElement;
            if (nextTextElBox.text.trim() != "") {
                startInlineObj.element = nextElement;
            }
        }
    };
    /**
     * Method to handle to ignore error Once
     *
     * @private
     */
    SpellChecker.prototype.handleIgnoreOnce = function (startInlineObj) {
        if (this.documentHelper.owner && this.documentHelper.owner.editorModule) {
            this.documentHelper.owner.editor.initHistory('IgnoreOnce');
        }
        var textElement = startInlineObj.element;
        // If text is split into multiple text elements, then we need to add ignoreOnceItems for all the text elements. So gets the start and end position of the text element and checks the same text exist which is in error element.
        if (!isNullOrUndefined(this.currentContextInfo) && this.currentContextInfo.element && this.currentContextInfo.element instanceof ErrorTextElementBox) {
            this.handleIgnoreOnceInternal(this.currentContextInfo.element, false);
        }
        else {
            var exactText = this.manageSpecialCharacters(textElement.text, undefined, true);
            if (textElement.ignoreOnceItems.indexOf(exactText) === -1) {
                textElement.ignoreOnceItems.push(exactText);
            }
            this.handleErrorElements.push(textElement);
        }
    };
    /**
     * Method to handle to ignore error Once intenral
     *
     * @private
     */
    SpellChecker.prototype.handleIgnoreOnceInternal = function (errorElement, isundoing) {
        var startPosition = errorElement.start;
        var endPosition = errorElement.end;
        var inlineObj = startPosition.currentWidget.getInline(startPosition.offset, 0, false, true);
        var startInlineObj = inlineObj.element;
        var endInlineObj = endPosition.currentWidget.getInline(endPosition.offset, 0, false, true).element;
        this.handleErrorElements.push(errorElement);
        if (this.documentHelper.selection.start && this.documentHelper.selection.start.paragraph && !this.documentHelper.selection.start.paragraph.isInHeaderFooter) {
            while (true) {
                if (startInlineObj.text === "" || startInlineObj.text === " ") {
                    startInlineObj = startInlineObj.nextNode;
                    if (inlineObj.index > 0) {
                        inlineObj.index = inlineObj.index - 1;
                    }
                }
                else {
                    break;
                }
            }
            if (startInlineObj instanceof TextElementBox) {
                this.splitTextBoxElement(startInlineObj, inlineObj.index, errorElement.text.length + inlineObj.index);
            }
            var currentErrorElement = this.updateErroElement(errorElement);
            if (currentErrorElement && currentErrorElement.text === errorElement.text) {
                startInlineObj = currentErrorElement;
                endInlineObj = currentErrorElement;
            }
        }
        while (true) {
            while (startInlineObj instanceof BookmarkElementBox) {
                startInlineObj = startInlineObj.nextNode;
                if (isNullOrUndefined(startInlineObj)) {
                    break;
                }
            }
            if (!isNullOrUndefined(startInlineObj)) {
                var exactText = this.manageSpecialCharacters(errorElement.text, undefined, true);
                var textIndex = startInlineObj && startInlineObj.ignoreOnceItems && startInlineObj.ignoreOnceItems.indexOf(exactText);
                if (isundoing) {
                    if (textIndex !== -1) {
                        startInlineObj.ignoreOnceItems.splice(textIndex, 1);
                    }
                }
                else {
                    if (textIndex === -1) {
                        startInlineObj.ignoreOnceItems.push(exactText);
                    }
                    this.handleErrorElements.push(startInlineObj);
                }
                if (startInlineObj === endInlineObj) {
                    break;
                }
                startInlineObj = startInlineObj.nextNode;
            }
            else {
                break;
            }
        }
    };
    /**
     * Method to handle ignore all items
     *
     * @private
     */
    SpellChecker.prototype.handleIgnoreAllItems = function (contextElement) {
        var contextItem = (!isNullOrUndefined(contextElement)) ? contextElement : this.retriveText();
        var retrievedText = this.manageSpecialCharacters(contextItem.text, undefined, true);
        if (this.ignoreAllItems.indexOf(retrievedText) === -1) {
            this.ignoreAllItems.push(retrievedText);
            if (!isNullOrUndefined(contextItem.element)) {
                this.handleErrorCollection(contextItem.element);
            }
            this.documentHelper.clearSelectionHighlight();
        }
    };
    /**
     * Method to handle dictionary
     *
     * @private
     */
    SpellChecker.prototype.handleAddToDictionary = function (contextElement) {
        var _this = this;
        var contextItem = (!isNullOrUndefined(contextElement)) ? contextElement : this.retriveText();
        var retrievedText = this.manageSpecialCharacters(contextItem.text, undefined, true);
        /* eslint-disable @typescript-eslint/no-explicit-any */
        this.callSpellChecker(this.languageID, retrievedText, false, false, true).then(function (data) {
            if (!isNullOrUndefined(_this.documentHelper)) {
                _this.documentHelper.triggerSpellCheck = true;
                _this.removeErrorsFromCollection(contextItem);
                _this.ignoreAllItems.push(retrievedText);
                // Build casing variants to suppress: original, Capitalized (if lower), and UPPER
                var casingWords = [];
                var text = contextItem.text;
                if (!isNullOrUndefined(text) && text.length > 1) {
                    if (text === text.toLowerCase()) {
                        var formattedText = text.charAt(0).toUpperCase() + text.substring(1);
                        if (formattedText !== text) {
                            casingWords.push(formattedText);
                        }
                    }
                    var upperCaseText = text.toUpperCase();
                    if (upperCaseText !== text) {
                        casingWords.push(upperCaseText);
                    }
                }
                for (var i = 0; i < casingWords.length; i++) {
                    var word = casingWords[i];
                    if (_this.ignoreAllItems.indexOf(word) === -1) {
                        _this.ignoreAllItems.push(word);
                    }
                    if (_this.errorWordCollection.containsKey(word)) {
                        var elements = _this.errorWordCollection.get(word);
                        if (elements && elements.length > 0) {
                            _this.removeErrorsFromCollection({ element: elements[0], text: word });
                        }
                    }
                }
                _this.documentHelper.owner.editorModule.reLayout(_this.documentHelper.selection, true);
                _this.documentHelper.triggerSpellCheck = false;
            }
        });
    };
    SpellChecker.prototype.splitTextBoxElement = function (inline, startIndex, endIndex) {
        this.skipChangeDetection = true;
        var currentElement = inline;
        var node = inline;
        var index = inline.line.children.indexOf(node);
        var paragraph = inline.paragraph;
        var textElement;
        var indexCountForRevision = 0;
        if (startIndex > 0) {
            indexCountForRevision += 1;
            textElement = new TextElementBox();
            textElement.characterFormat.copyFormat(inline.characterFormat);
            if (!isNullOrUndefined(inline.contentControlProperties)) {
                textElement.contentControlProperties = inline.contentControlProperties;
            }
            textElement.line = inline.line;
            textElement.text = inline.text.substr(startIndex, endIndex - startIndex);
            textElement.isRightToLeft = inline.isRightToLeft;
            this.updateErrorCollectionForSplitElement(inline, textElement, startIndex);
            index++;
            node.line.children.splice(index, 0, textElement);
            this.documentHelper.owner.editorModule.updateRevisionForFormattedContent(inline, textElement, indexCountForRevision);
            // currentElement = textElement;
            inline.isWidthUpdated = false;
        }
        if (endIndex < node.length) {
            indexCountForRevision += 1;
            textElement = new TextElementBox();
            textElement.characterFormat.copyFormat(inline.characterFormat);
            if (!isNullOrUndefined(inline.contentControlProperties)) {
                textElement.contentControlProperties = inline.contentControlProperties;
            }
            textElement.text = node.text.substring(endIndex);
            textElement.line = inline.line;
            this.updateErrorCollectionForSplitElement(inline, textElement, endIndex);
            textElement.isRightToLeft = inline.isRightToLeft;
            index++;
            node.line.children.splice(index, 0, textElement);
            this.documentHelper.owner.editorModule.updateRevisionForFormattedContent(inline, textElement, indexCountForRevision);
            inline.isWidthUpdated = false;
        }
        if (startIndex === 0) {
            inline.text = inline.text.substr(0, endIndex);
        }
        else {
            inline.text = inline.text.substr(0, startIndex);
        }
        this.documentHelper.layout.reLayoutParagraph(paragraph, inline.line.indexInOwner, 0, false, false);
        this.skipChangeDetection = false;
        return currentElement;
    };
    SpellChecker.prototype.updateErroElement = function (errorElement) {
        var startPosition = errorElement.start;
        var endPosition = errorElement.end;
        for (var i = 0; i < startPosition.currentWidget.children.length; i++) {
            var errorCollection = startPosition.currentWidget.children[i].errorCollection;
            if (errorCollection && errorCollection.indexOf(errorElement) === 0) {
                return startPosition.currentWidget.children[i];
            }
        }
        return null;
    };
    /**
     * Method to append/remove special characters
     *
     * @private
     */
    SpellChecker.prototype.manageSpecialCharacters = function (exactText, replaceText, isRemove) {
        if (!isNullOrUndefined(exactText)) {
            var isRemoveSpecChar = false;
            if (isNullOrUndefined(replaceText)) {
                isRemoveSpecChar = true;
                replaceText = exactText;
            }
            var pattern = new RegExp('^[#\\@\\!\\$\\%\\^\\&\\*\\(\\)\\-\\_\\+\\=\\{\\}\\[\\]\\:\\;\\"\\”\'\\,\\<\\.\\>\\/\\?\\`\\s\\’]+', 'g');
            var matches = [];
            var matchInfo = void 0;
            // eslint-disable  no-cond-assign
            while (!isNullOrUndefined(matchInfo = pattern.exec(exactText))) {
                matches.push(matchInfo);
            }
            if (matches.length > 0) {
                for (var i = 0; i < matches.length; i++) {
                    /* eslint-disable @typescript-eslint/no-explicit-any */
                    var match = matches[i];
                    replaceText = (!isRemove) ? match[0] + replaceText : replaceText.replace(match[0], '');
                }
            }
            var endPattern = new RegExp('[#\\@\\!\\$\\%\\^\\&\\*\\(\\)\\-\\_\\+\\=\\{\\}\\[\\]\\:\\;\\"\\”\'\\,\\<\\>\\/\\?\\s\\`\\’]+$', 'g');
            matches = [];
            var originalText = replaceText;
            if (!isRemove) {
                originalText = exactText;
            }
            // eslint-disable  no-cond-assign
            while (!isNullOrUndefined(matchInfo = endPattern.exec(originalText))) {
                matches.push(matchInfo);
            }
            if (matches.length > 0) {
                for (var i = 0; i < matches.length; i++) {
                    /* eslint-disable @typescript-eslint/no-explicit-any */
                    var match = matches[i];
                    replaceText = (!isRemove) ? replaceText + match[0] : replaceText.slice(0, match.index);
                }
            }
            // if the text contains zero width characters, remove them.
            var zeroWidthPattern = /[\u200B-\u200D\uFEFF]/g;
            replaceText = replaceText.replace(zeroWidthPattern, '');
        }
        return replaceText;
    };
    /**
     * Method to remove errors
     *
     * @private
     */
    SpellChecker.prototype.removeErrorsFromCollection = function (contextItem) {
        if (!isNullOrUndefined(contextItem.text) && this.errorWordCollection.containsKey(contextItem.text)) {
            var textElement = this.errorWordCollection.get(contextItem.text);
            if (textElement.indexOf(contextItem.element) >= 0) {
                textElement.splice(textElement.indexOf(contextItem.element), 1);
            }
            if (textElement.length === 0) {
                this.errorWordCollection.remove(contextItem.text);
            }
        }
    };
    /**
     * Method to retrieve exact text
     *
     * @private
     */
    SpellChecker.prototype.retriveText = function () {
        var exactText;
        var currentElement;
        if (!isNullOrUndefined(this.currentContextInfo) && this.currentContextInfo.element instanceof ErrorTextElementBox) {
            currentElement = this.currentContextInfo.element;
            exactText = this.currentContextInfo.element.text;
            this.documentHelper.selection.start = currentElement.start.clone();
            this.documentHelper.selection.end = currentElement.end.clone();
        }
        else {
            var startPosition = this.documentHelper.selection.start;
            var offset = startPosition.offset;
            var startIndex = 0;
            var startInlineObj = startPosition.currentWidget.getInline(offset, startIndex);
            currentElement = startInlineObj.element;
            exactText = startInlineObj.element.text;
        }
        return { 'text': exactText, 'element': currentElement };
    };
    /**
     * Method to handle suggestions
     *
     * @private
     */
    /* eslint-disable @typescript-eslint/no-explicit-any */
    SpellChecker.prototype.handleSuggestions = function (allsuggestions) {
        this.spellCheckSuggestion = [];
        if (allsuggestions.length === 0) {
            this.spellCheckSuggestion.push(this.documentHelper.owner.contextMenuModule.locale.getConstant('Add to Dictionary'));
        }
        else {
            allsuggestions = (allsuggestions.length > 3) ? this.constructInlineMenu(allsuggestions) : allsuggestions;
            this.spellCheckSuggestion.push(this.documentHelper.owner.contextMenuModule.locale.getConstant('Add to Dictionary'));
        }
        /* eslint-disable @typescript-eslint/no-explicit-any */
        var spellSuggestion = [];
        if (this.spellCheckSuggestion.length > 0) {
            for (var _i = 0, _a = this.spellCheckSuggestion; _i < _a.length; _i++) {
                var str = _a[_i];
                spellSuggestion.push({
                    text: str,
                    id: this.documentHelper.owner.element.id + '_contextmenu_otherSuggestions_spellcheck_' + (str === this.documentHelper.owner.contextMenuModule.locale.getConstant('Add to Dictionary') ? 'Add to Dictionary' : str),
                    iconCss: ''
                });
            }
        }
        return spellSuggestion;
    };
    /**
     * Method to check whether text element has errors
     *
     * @private
     */
    SpellChecker.prototype.checktextElementHasErrors = function (text, element, left) {
        var hasError = false;
        var erroElements = [];
        text = text.replace(/[\s]+/g, '');
        if (!isNullOrUndefined(element.errorCollection) && element.errorCollection.length > 0) {
            if (!this.documentHelper.isScrollHandler && (element.isChangeDetected || element.paragraph.isChangeDetected) && !element.istextCombined) {
                this.updateStatusForGlobalErrors(element.errorCollection, element);
                element.errorCollection = [];
                element.isChangeDetected = true;
                return { 'errorFound': hasError, 'elements': erroElements };
            }
            for (var i = 0; i < element.errorCollection.length; i++) {
                if (this.handleErrorCollection(element.errorCollection[i])) {
                    hasError = true;
                    erroElements.push(element.errorCollection[i]);
                }
            }
        }
        else if (!this.documentHelper.isScrollHandler && element.paragraph.isChangeDetected) {
            element.isChangeDetected = true;
        }
        else if (!element.isChangeDetected) {
            if (this.handleErrorCollection(element)) {
                hasError = true;
                erroElements.push(element);
            }
            else if (!this.enableUserDictionary && !isNullOrUndefined(element.currentUser)) {
                // Set isChangeDetected to true since the enableUserDictionary property changed from true to false,
                // so we need to re-evaluate the word
                element.isChangeDetected = true;
                element.currentUser = undefined;
            }
            else if (this.enableUserDictionary && element.currentUser !== (this.documentHelper.owner.currentUser === '' ? 'Guest user' : this.documentHelper.owner.currentUser)) {
                // Set isChangeDetected to true since the enableUserDictionary property changed from false to true or the user is switched,
                // so we need to re-evaluate the word
                element.isChangeDetected = true;
                element.currentUser = this.documentHelper.owner.currentUser === '' ? 'Guest user' : this.documentHelper.owner.currentUser;
            }
        }
        // If the user-specific dictionary is enabled and the current user is not defined, set the current user
        if ((this.enableUserDictionary && isNullOrUndefined(element.currentUser))) {
            element.currentUser = this.documentHelper.owner.currentUser === '' ? 'Guest user' : this.documentHelper.owner.currentUser;
        }
        return { 'errorFound': hasError, 'elements': erroElements };
    };
    SpellChecker.prototype.updateStatusForGlobalErrors = function (erroElements, parentElement) {
        if (erroElements.length > 0) {
            for (var i = 0; i < erroElements.length; i++) {
                var exactText = this.manageSpecialCharacters(erroElements[i].text, undefined, true);
                if (this.errorWordCollection.containsKey(exactText)) {
                    var elements = this.errorWordCollection.get(exactText);
                    for (var j = 0; j < elements.length; j++) {
                        if (elements[j] instanceof ErrorTextElementBox && elements[j] === erroElements[i]) {
                            elements[j].isChangeDetected = true;
                            elements[j].start.offset = parentElement.line.getOffset(parentElement.istextCombined ? this.getCombinedElement(parentElement) : parentElement, 0);
                            elements[j].line = parentElement.line;
                            break;
                        }
                    }
                }
            }
        }
    };
    /**
     * Method to handle document error collection.
     *
     * @param {string} errorInElement
     * @private
     */
    SpellChecker.prototype.handleErrorCollection = function (errorInElement) {
        var errors = this.errorWordCollection;
        var exactText = this.manageSpecialCharacters(errorInElement.text, undefined, true);
        if (errors.containsKey(exactText) && errorInElement.length > 1) {
            var ignoreAllIndex = this.ignoreAllItems.indexOf(exactText);
            if (ignoreAllIndex > -1) {
                if (errors.containsKey(exactText)) {
                    errors.remove(exactText);
                }
                return false;
            }
            return true;
        }
        return false;
    };
    /* eslint-disable @typescript-eslint/no-explicit-any */
    SpellChecker.prototype.constructInlineMenu = function (inlineSuggestion) {
        for (var i = inlineSuggestion.length - 1; i > 0; i--) {
            if (inlineSuggestion.length > 3) {
                this.spellCheckSuggestion.push(inlineSuggestion[i]);
                inlineSuggestion.pop();
            }
        }
        return inlineSuggestion;
    };
    /**
     * Method to retrieve error element text
     *
     * @private
     */
    SpellChecker.prototype.findCurretText = function () {
        var insertPosition = this.documentHelper.selection.start;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        var element;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        var inlineObj = insertPosition.currentWidget.getInline(this.documentHelper.selection.start.offset, 0);
        var text;
        // If selection is in header/footer prefer header/footer error element
        if (!isNullOrUndefined(insertPosition.currentWidget) && insertPosition.currentWidget.paragraph && insertPosition.currentWidget.paragraph.isInHeaderFooter) {
            var errorWords = this.errorWordCollection;
            var currentWord = this.getErrorWordText(inlineObj.element.text);
            var exactKey = this.manageSpecialCharacters(currentWord, undefined, true);
            if (errorWords.length > 0) {
                var errorElements = errorWords.get(exactKey);
                if (!isNullOrUndefined(errorElements)) {
                    for (var elementIndex = 0; elementIndex < errorElements.length; elementIndex++) {
                        var collectionElement = errorElements[elementIndex];
                        if (collectionElement instanceof ErrorTextElementBox) {
                            if (!isNullOrUndefined(collectionElement.start.paragraph) && collectionElement.start.paragraph.isInHeaderFooter) {
                                if (collectionElement.start && collectionElement.end && collectionElement.start.offset <= insertPosition.offset && collectionElement.end.offset >= insertPosition.offset) {
                                    return { 'text': collectionElement.text, 'element': collectionElement };
                                }
                            }
                        }
                        else if (collectionElement instanceof TextElementBox) {
                            if (collectionElement.line && collectionElement.line.paragraph && collectionElement.line.paragraph.isInHeaderFooter) {
                                var matchResults = this.getMatchedResultsFromElement(collectionElement);
                                var results = matchResults.textResults;
                                var markIndex = (collectionElement.isChangeDetected && !isNullOrUndefined(collectionElement.start)) ? collectionElement.start.offset : collectionElement.line.getOffset(collectionElement, 0);
                                this.documentHelper.owner.searchModule.textSearch.updateMatchedTextLocation(matchResults.matches, results, matchResults.elementInfo, 0, collectionElement, false, null, markIndex);
                                for (var resultIndex = 0; resultIndex < results.length; resultIndex++) {
                                    var errorElement = this.createErrorElementWithInfo(results.innerList[resultIndex], collectionElement);
                                    if (errorElement.start && errorElement.end && errorElement.start.paragraph.isInHeaderFooter) {
                                        if (errorElement.start.offset <= insertPosition.offset && errorElement.end.offset >= insertPosition.offset) {
                                            return { 'text': errorElement.text, 'element': errorElement };
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (!isNullOrUndefined(inlineObj.element)) {
            if (!isNullOrUndefined(inlineObj.element.errorCollection) && inlineObj.element.errorCollection.length > 0) {
                for (var i = 0; i < inlineObj.element.errorCollection.length; i++) {
                    var errorElement = inlineObj.element.errorCollection[i];
                    // If the cursor is in error element, then we need to retrieve the text from that error element.
                    if (errorElement.start.isExistBefore(this.documentHelper.selection.start) && errorElement.end.isExistAfter(this.documentHelper.selection.start)) {
                        text = errorElement.text;
                        element = errorElement;
                        break;
                    }
                }
            }
            else {
                text = inlineObj.element.text;
                element = inlineObj.element;
            }
            if (text === ' ') {
                inlineObj = insertPosition.currentWidget.getInline(this.documentHelper.selection.start.offset + 1, 0);
                text = inlineObj.element.text;
            }
        }
        return { 'text': text, 'element': element };
    };
    SpellChecker.prototype.addErrorCollection = function (text, elementToCompare, suggestions) {
        text = this.manageSpecialCharacters(text, undefined, true);
        if (this.errorWordCollection.containsKey(text)) {
            var errorElements = this.errorWordCollection.get(text);
            if (elementToCompare instanceof ErrorTextElementBox) {
                if (!this.compareErrorTextElement(elementToCompare, errorElements)) {
                    errorElements.push(elementToCompare);
                }
            }
            else if (elementToCompare instanceof TextElementBox) {
                if (!this.compareTextElement(elementToCompare, errorElements)) {
                    errorElements.push(elementToCompare);
                }
            }
        }
        else {
            if (!isNullOrUndefined(suggestions) && suggestions.length > 0) {
                this.errorSuggestions.add(text, suggestions);
            }
            this.errorWordCollection.add(text, [elementToCompare]);
            if (!this.uniqueWordsCollection.containsKey(text)) {
                this.uniqueWordsCollection.add(text, true);
            }
        }
    };
    /**
     * Updates the error collection when a new error element is created.
     * If an existing error element with matching offsets is found, it is replaced.
     */
    SpellChecker.prototype.updateErrorCollection = function (text, elementToCompare) {
        var isChanged = false;
        if (this.errorWordCollection.containsKey(text)) {
            var errorElements = this.errorWordCollection.get(text);
            if (elementToCompare instanceof ErrorTextElementBox && errorElements.length > 0) {
                for (var i = 0; i < errorElements.length; i++) {
                    var currentElement = errorElements[i];
                    if (currentElement instanceof ErrorTextElementBox) {
                        if (elementToCompare.start.offset === currentElement.start.offset &&
                            elementToCompare.end.offset === currentElement.end.offset) {
                            this.removeErrorsFromCollection({ 'element': errorElements[i], 'text': text });
                            isChanged = true;
                        }
                    }
                }
                if (isChanged) {
                    errorElements.push(elementToCompare);
                }
            }
        }
    };
    /**
     * Method to retrieve error text if text is not matched with error word collection
     *
     * @private
     */
    SpellChecker.prototype.getErrorWordText = function (text) {
        var start = this.documentHelper.selection.start.clone();
        var end = this.documentHelper.selection.end.clone();
        this.documentHelper.selection.isModifyingSelectionInternally = true;
        this.documentHelper.selection.selectCurrentWord();
        var currentWord = this.documentHelper.selection.text;
        var exactData = this.manageSpecialCharacters(currentWord, undefined, true);
        if (!isNullOrUndefined(exactData) && this.errorWordCollection.containsKey(exactData)) {
            currentWord = exactData;
        }
        else {
            currentWord = text;
        }
        this.documentHelper.selection.selectRange(start, end);
        this.documentHelper.selection.isModifyingSelectionInternally = false;
        return currentWord;
    };
    SpellChecker.prototype.addCorrectWordCollection = function (text) {
        text = this.manageSpecialCharacters(text, undefined, true);
        if (!this.uniqueWordsCollection.containsKey(text)) {
            this.uniqueWordsCollection.add(text, false);
        }
    };
    /**
     * @private
     */
    SpellChecker.prototype.isInUniqueWords = function (text) {
        text = text.replace(/[\s]+/g, '');
        return this.uniqueWordsCollection.containsKey(text);
    };
    /**
     * @private
     */
    SpellChecker.prototype.isErrorWord = function (text) {
        text = text.replace(/[\s]+/g, '');
        return this.uniqueWordsCollection.get(text);
    };
    /**
     * @private
     */
    SpellChecker.prototype.isCorrectWord = function (text) {
        text = text.replace(/[\s]+/g, '');
        return !this.uniqueWordsCollection.get(text);
    };
    SpellChecker.prototype.compareErrorTextElement = function (errorElement, errorCollection) {
        var copyElement = [];
        var isChanged = false;
        for (var i = 0; i < errorCollection.length; i++) {
            copyElement.push(errorCollection[i]);
        }
        var length = errorCollection.length;
        for (var i = 0; i < length; i++) {
            if (copyElement[i] instanceof ErrorTextElementBox) {
                if (copyElement[i].isChangeDetected) {
                    var exactText = this.manageSpecialCharacters(copyElement[i].text, undefined, true);
                    isChanged = true;
                    this.removeErrorsFromCollection({ 'element': copyElement[i], 'text': exactText });
                }
                else {
                    var currentElement = copyElement[i];
                    if (errorElement.start.offset === currentElement.start.offset && errorElement.end.offset === currentElement.end.offset && currentElement === errorElement) {
                        return true;
                    }
                }
            }
        }
        if (isChanged) {
            this.errorWordCollection.add(this.manageSpecialCharacters(errorElement.text, undefined, true), [errorElement]);
        }
        return false;
    };
    /**
     * Method to compare text elements
     *
     * @private
     */
    SpellChecker.prototype.compareTextElement = function (errorElement, errorCollection) {
        for (var i = 0; i < errorCollection.length; i++) {
            if (errorCollection[i] instanceof TextElementBox) {
                var currentElement = errorCollection[i];
                if (currentElement === errorElement) {
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * Method to handle Word by word spell check
     *
     * @private
     */
    SpellChecker.prototype.handleWordByWordSpellCheck = function (jsonObject, elementBox, left, top, underlineY, baselineAlignment, isSamePage, currentText) {
        if (isNullOrUndefined(currentText)) {
            currentText = elementBox.text;
        }
        if (jsonObject.HasSpellingError && isSamePage) {
            this.addErrorCollection(currentText, elementBox, jsonObject.Suggestions);
            if (currentText.trim() === elementBox.text.trim()) {
                var backgroundColor = (elementBox.line.paragraph.containerWidget instanceof TableCellWidget) ? elementBox.line.paragraph.containerWidget.cellFormat.shading.backgroundColor : this.documentHelper.backgroundColor;
                this.documentHelper.render.renderWavyLine(elementBox, left, top, underlineY, '#FF0000', 'Single', baselineAlignment, backgroundColor);
                elementBox.isSpellChecked = true;
            }
        }
        else {
            this.addCorrectWordCollection(currentText);
            elementBox.isSpellChecked = true;
        }
    };
    /**
     * Method to check errors for combined elements
     *
     * @private
     */
    SpellChecker.prototype.checkElementCanBeCombined = function (elementBox, underlineY, beforeIndex, callSpellChecker, textToCombine, isNext, isPrevious, canCombine) {
        var currentText = isNullOrUndefined(textToCombine) ? '' : textToCombine;
        var isCombined = isNullOrUndefined(canCombine) ? false : canCombine;
        var checkPrevious = !isNullOrUndefined(isPrevious) ? isPrevious : true;
        var checkNext = !isNullOrUndefined(isNext) ? isNext : true;
        var line = this.documentHelper.selection.getLineWidget(elementBox, 0);
        var index = line.children.indexOf(elementBox);
        var prevText = elementBox.text;
        if (this.combinedElements.indexOf(elementBox) === -1) {
            elementBox.isChangeDetected = false;
            this.combinedElements.push(elementBox);
        }
        var difference = (isPrevious) ? 0 : 1;
        var prevCombined = false;
        var isPrevField = false;
        var forbiddenChars = /[#@!$%^&*()\-_\+=\{\}\[\]:;"”',<>\/?\s`’\\]/;
        var boundaryRegexStart = new RegExp("^" + forbiddenChars.source + "+");
        var boundaryRegexEnd = new RegExp(forbiddenChars.source + "+$");
        if (elementBox.text !== '\v') {
            if (checkPrevious) {
                var textElement = undefined;
                for (var i = index - difference; i >= 0; i--) {
                    textElement = line.children[i];
                    if (!isNullOrUndefined(textElement) && textElement.revisionLength > 0 && textElement.getRevision(0).revisionType === "Deletion") {
                        break;
                    }
                    var prevTextCheck = !boundaryRegexStart.test(prevText) && !boundaryRegexEnd.test(textElement.text);
                    if (textElement instanceof TextElementBox && !isPrevField && !(textElement instanceof FootnoteElementBox)) {
                        if (prevText.indexOf(' ') !== 0 && textElement.text.lastIndexOf(' ') !== textElement.text.length - 1 &&
                            prevText.indexOf('\t') !== 0 && textElement.text.lastIndexOf('\t') !== textElement.text.length - 1 &&
                            prevText.indexOf('[') !== 0 && textElement.text.lastIndexOf('[') !== textElement.text.length - 1 &&
                            prevText.indexOf(']') !== 0 && textElement.text.lastIndexOf(']') !== textElement.text.length - 1 &&
                            prevTextCheck) {
                            prevCombined = !isNullOrUndefined(textToCombine) ? true : false;
                            currentText = textElement.text + currentText;
                            prevText = textElement.text;
                            isPrevField = false;
                            if (this.combinedElements.indexOf(textElement) === -1) {
                                this.combinedElements.push(textElement);
                            }
                            isCombined = true;
                        }
                        else if (!isNullOrUndefined(textElement)) {
                            textElement = textElement.nextElement;
                            break;
                        }
                    }
                    else if (textElement instanceof FieldElementBox && textElement.fieldType !== 1) {
                        isPrevField = true;
                    }
                }
                var currentElement = (isCombined) ? textElement : elementBox;
                if (this.lookThroughPreviousLine(currentText, prevText, currentElement, underlineY, beforeIndex)) {
                    this.combinedElements.length = 0;
                    return true;
                }
            }
            if (!(elementBox instanceof FootnoteElementBox)) {
                if (isPrevious) {
                    currentText = (prevCombined) ? currentText : elementBox.text + currentText;
                }
                else {
                    currentText += elementBox.text;
                }
            }
            isPrevField = false;
            var nextText = elementBox.text;
            if (checkNext) {
                var canCombine_1 = false;
                var element = undefined;
                for (var i = index + 1; i < line.children.length; i++) {
                    element = line.children[i];
                    if (!isNullOrUndefined(element) && element.revisionLength > 0 && element.getRevision(0).revisionType === "Deletion") {
                        break;
                    }
                    var nextTextCheck = !boundaryRegexEnd.test(nextText) && !boundaryRegexStart.test(element.text);
                    if (element instanceof TextElementBox && !isPrevField && !(element instanceof FootnoteElementBox)) {
                        if (nextText.lastIndexOf(' ') !== nextText.length - 1 && element.text.indexOf(' ') !== 0 &&
                            nextText.lastIndexOf('\t') !== nextText.length - 1 && element.text.indexOf('\t') !== 0 &&
                            nextText.lastIndexOf('[') !== nextText.length - 1 && element.text.indexOf('[') !== 0 &&
                            nextText.lastIndexOf(']') !== nextText.length - 1 && element.text.indexOf(']') !== 0 &&
                            nextTextCheck) {
                            currentText += element.text;
                            nextText = element.text;
                            isPrevField = false;
                            this.combinedElements.push(element);
                            canCombine_1 = true;
                            isCombined = true;
                        }
                        else if (!isNullOrUndefined(element)) {
                            element = element.previousElement;
                            break;
                        }
                    }
                    else if (element instanceof FieldElementBox && element.fieldType !== 2) {
                        isPrevField = true;
                    }
                }
                var currentElement = (canCombine_1) ? element : elementBox;
                if (currentElement.text !== '\f' && currentElement.text !== String.fromCharCode(14) && this.lookThroughNextLine(currentText, prevText, currentElement, underlineY, beforeIndex)) {
                    this.combinedElements.length = 0;
                    return true;
                }
            }
        }
        if (isCombined && callSpellChecker && !this.checkCombinedElementsBeIgnored(this.combinedElements, currentText)) {
            if (isPrevious || isNext) {
                for (var i = 0; i < this.combinedElements.length; i++) {
                    this.combinedElements[i].isChangeDetected = false;
                    if (i !== 0) {
                        this.combinedElements[i].istextCombined = true;
                        this.combinedElements[i].errorCollection = this.combinedElements[0].errorCollection;
                    }
                }
            }
            else {
                for (var i = 0; i < this.combinedElements.length; i++) {
                    this.combinedElements[i].isChangeDetected = false;
                    if (i !== 0) {
                        this.combinedElements[i].istextCombined = true;
                        this.combinedElements[i].errorCollection = this.combinedElements[0].errorCollection;
                    }
                }
                this.combinedElements.length = 0;
            }
            this.handleCombinedElements(elementBox, currentText, underlineY);
        }
        this.combinedElements.length = 0;
        return isCombined;
    };
    SpellChecker.prototype.lookThroughPreviousLine = function (currentText, prevText, currentElement, underlineY, beforeIndex) {
        if (!isNullOrUndefined(currentElement) && currentElement.indexInOwner === 0 && !isNullOrUndefined(currentElement.line.previousLine)) {
            var previousLine = currentElement.line.previousLine;
            var index = previousLine.children.length - 1;
            if (!isNullOrUndefined(previousLine.children[index]) && previousLine.children[index] instanceof TextElementBox) {
                var firstElement = previousLine.children[index];
                if (!isNullOrUndefined(currentElement.text)) {
                    if (currentElement.text.indexOf(' ') !== 0 && firstElement.text.lastIndexOf(' ') !== firstElement.text.length - 1 && !(firstElement.text === '\v' || firstElement.text === '\t' || firstElement.text === '\f')) {
                        currentText = (currentText.length > 0) ? currentText : prevText;
                        this.checkElementCanBeCombined(firstElement, underlineY, beforeIndex, true, currentText, false, true, true);
                        return true;
                    }
                }
            }
        }
        return false;
    };
    SpellChecker.prototype.lookThroughNextLine = function (currentText, prevText, elementBox, underlineY, beforeIndex) {
        if (elementBox instanceof TextElementBox && !isNullOrUndefined(elementBox) && elementBox.indexInOwner === elementBox.line.children.length - 1 && !isNullOrUndefined(elementBox.line.nextLine)) {
            var nextLine = elementBox.line.nextLine;
            if (!isNullOrUndefined(nextLine.children[0]) && nextLine.children[0] instanceof TextElementBox) {
                var firstElement = nextLine.children[0];
                if (elementBox.text.lastIndexOf(' ') !== elementBox.text.length - 1 && firstElement.text.indexOf(' ') !== 0 && !(elementBox.text === '\v' || elementBox.text === '\t' || elementBox.text === '\f')) {
                    currentText = (currentText.length > 0) ? currentText : prevText;
                    this.checkElementCanBeCombined(firstElement, underlineY, beforeIndex, true, currentText, true, false, true);
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * Method to handle combined elements
     *
     * @param {TextElementBox} elementBox
     * @param {string} currentText
     * @param {number} underlineY
     * @param {number} beforeIndex
     * @private
     */
    SpellChecker.prototype.handleCombinedElements = function (elementBox, currentText, underlineY) {
        var splittedText = currentText.split(/[()\s{}\[\]]+/);
        if (this.ignoreAllItems.indexOf(currentText) === -1 && elementBox instanceof TextElementBox && elementBox.ignoreOnceItems.indexOf(currentText) === -1) {
            if (splittedText.length > 1) {
                for (var i = 0; i < splittedText.length; i++) {
                    var currentText_1 = splittedText[i];
                    currentText_1 = this.manageSpecialCharacters(currentText_1, undefined, true);
                    if (this.ignoreAllItems.indexOf(currentText_1) === -1 && elementBox instanceof TextElementBox && elementBox.ignoreOnceItems.indexOf(currentText_1) === -1) {
                        this.documentHelper.render.handleUnorderedElements(currentText_1, elementBox, underlineY, i, 0, i === splittedText.length - 1, this.combinedElements);
                    }
                }
            }
            else {
                currentText = this.manageSpecialCharacters(currentText, undefined, true);
                var text = currentText.split(/[()\s{}\[\]]+/);
                currentText = text[0];
                this.documentHelper.render.handleUnorderedElements(currentText, elementBox, underlineY, 0, 0, true, this.combinedElements);
            }
        }
    };
    /**
     * Method to check error element collection has unique element
     *
     * @param {ErrorTextElementBox[]} errorCollection
     * @param {ErrorTextElementBox} elementToCheck
     * @private
     */
    SpellChecker.prototype.checkArrayHasSameElement = function (errorCollection, elementToCheck) {
        for (var i = 0; i < errorCollection.length; i++) {
            var errorText = errorCollection[i];
            if ((errorText.start.location.x === elementToCheck.start.location.x) && (errorText.start.location.y === elementToCheck.start.location.y)) {
                return true;
            }
        }
        return false;
    };
    /**
     * @private
     */
    SpellChecker.prototype.handleSplitWordSpellCheck = function (jsonObject, currentText, elementBox, isSamePage, underlineY, iteration, markIndex, isLastItem, combinedElements) {
        if (jsonObject.HasSpellingError && elementBox.text !== ' ' && isSamePage) {
            var textSearch = this.documentHelper.owner.searchModule.textSearch;
            var matchResults = this.getMatchedResultsFromElement(elementBox, currentText);
            // Handled combined elements split to multiple lines when textResults is empty.
            // Only the first element will be rendered with wavy line. Other elements will be rendered in renderTextElementBox method in render Element.
            if (!isNullOrUndefined(combinedElements) && matchResults.textResults.length === 0 && combinedElements.length > 0) {
                var combinedElement = combinedElements[0];
                matchResults = this.getMatchedResultsFromElement(combinedElement, combinedElement.text);
                markIndex = combinedElement.line.getOffset(this.getCombinedElement(combinedElement), 0);
                textSearch.updateMatchedTextLocation(matchResults.matches, matchResults.textResults, matchResults.elementInfo, 0, combinedElement, false, null, markIndex);
                this.handleMatchedResults(matchResults.textResults, combinedElement, underlineY, iteration, jsonObject.Suggestions, false, currentText, combinedElements);
            }
            else {
                markIndex = (elementBox.istextCombined) ? elementBox.line.getOffset(this.getCombinedElement(elementBox), 0) : markIndex;
                textSearch.updateMatchedTextLocation(matchResults.matches, matchResults.textResults, matchResults.elementInfo, 0, elementBox, false, null, markIndex);
                this.handleMatchedResults(matchResults.textResults, elementBox, underlineY, iteration, jsonObject.Suggestions, isLastItem);
            }
        }
        else {
            this.addCorrectWordCollection(currentText);
            if (isLastItem) {
                elementBox.isSpellChecked = true;
            }
        }
        this.updateUniqueWord([{ Text: currentText, HasSpellError: jsonObject.HasSpellingError }]);
    };
    SpellChecker.prototype.handleMatchedResults = function (results, elementBox, wavyLineY, index, suggestions, isLastItem, errorText, combinedElements) {
        if (results.length === 0 && isLastItem) {
            elementBox.isSpellChecked = true;
            return;
        }
        for (var i = 0; i < results.length; i++) {
            var span = this.createErrorElementWithInfo(results.innerList[i], elementBox);
            // Updated the error text and text position for combined elements.
            if (!isNullOrUndefined(errorText)) {
                span.text = errorText;
                var startElement = combinedElements[0];
                var endElement = combinedElements[combinedElements.length - 1];
                // Set the start and end position for the error element when text is splitted into multiple lines.
                if (startElement && endElement) {
                    var offset = startElement.line.getOffset(startElement, 0);
                    var startPosition = new TextPosition(this.documentHelper.owner);
                    startPosition.setPositionParagraph(startElement.line, offset);
                    offset = endElement.line.getOffset(endElement, (endElement.length));
                    var endPosition = new TextPosition(this.documentHelper.owner);
                    endPosition.setPositionParagraph(endElement.line, offset);
                    span.start = startPosition;
                    span.end = endPosition;
                }
            }
            var color = '#FF0000';
            if (!isNullOrUndefined(elementBox.errorCollection) && !this.checkArrayHasSameElement(elementBox.errorCollection, span)) {
                elementBox.errorCollection.splice(index, 0, span);
            }
            this.addErrorCollection(span.text, span, suggestions);
            var elements = this.errorWordCollection.get(span.text);
            if (!isNullOrUndefined(elements) && elements.indexOf(elementBox) !== -1 && elements.indexOf(elementBox) !== elements.indexOf(span)) {
                elements.splice(elements.indexOf(elementBox), 1);
            }
            var backgroundColor = (elementBox.line.paragraph.containerWidget instanceof TableCellWidget) ? elementBox.paragraph.containerWidget.cellFormat.shading.backgroundColor : this.documentHelper.backgroundColor;
            var para = elementBox.line.paragraph;
            var lineY = para.y;
            for (var i_1 = 0; i_1 < para.childWidgets.length; i_1++) {
                if (para.childWidgets[i_1] == elementBox.line)
                    break;
                lineY += para.childWidgets[i_1].height;
            }
            if (elementBox.isRightToLeft) {
                this.documentHelper.render.renderWavyLine(span, span.end.location.x, lineY, wavyLineY, color, 'Single', elementBox.characterFormat.baselineAlignment, backgroundColor);
            }
            else {
                this.documentHelper.render.renderWavyLine(span, span.start.location.x, lineY, wavyLineY, color, 'Single', elementBox.characterFormat.baselineAlignment, backgroundColor);
            }
            if (isLastItem) {
                elementBox.isSpellChecked = true;
            }
        }
    };
    /**
     * Calls the spell checker service.
     * @private
     */
    /* eslint-disable @typescript-eslint/no-explicit-any */
    SpellChecker.prototype.callSpellChecker = function (languageID, word, checkSpelling, checkSuggestion, addWord, isByPage) {
        var _this = this;
        var spellchecker = this;
        return new Promise(function (resolve, reject) {
            if (!isNullOrUndefined(_this)) {
                var httpRequest_1 = new XMLHttpRequest();
                var service_1 = _this.documentHelper.owner.serviceUrl;
                service_1 = (isByPage) ? service_1 + _this.documentHelper.owner.serverActionSettings.spellCheckByPage : service_1 + _this.documentHelper.owner.serverActionSettings.spellCheck;
                httpRequest_1.open('POST', service_1, true);
                httpRequest_1.setRequestHeader('Content-Type', 'application/json');
                var headers = _this.documentHelper.owner.headers;
                /* eslint-disable @typescript-eslint/no-explicit-any */
                if (isByPage) {
                    word = word.replace(String.fromCharCode(160), ' ');
                }
                var spellCheckData = { LanguageID: languageID, TexttoCheck: word, CheckSpelling: checkSpelling, CheckSuggestion: checkSuggestion, AddWord: addWord, IgnoreUppercase: _this.ignoreUppercase };
                if (_this.enableUserDictionary) {
                    spellCheckData.UserName = _this.documentHelper.owner.currentUser === '' ? 'Guest user' : _this.documentHelper.owner.currentUser;
                }
                var httprequestEventArgs = { serverActionType: 'SpellCheck', headers: headers, timeout: 0, cancel: false, withCredentials: false };
                headers = httprequestEventArgs.headers;
                _this.documentHelper.owner.trigger(beforeXmlHttpRequestSend, httprequestEventArgs);
                _this.setCustomHeaders(httpRequest_1, httprequestEventArgs.headers);
                httpRequest_1.withCredentials = httprequestEventArgs.withCredentials;
                if (!httprequestEventArgs.cancel) {
                    httpRequest_1.send(JSON.stringify(spellCheckData));
                }
                httpRequest_1.onreadystatechange = function () {
                    if (httpRequest_1.readyState === 4) {
                        if (httpRequest_1.status === 200 || httpRequest_1.status === 304) {
                            resolve(httpRequest_1.response);
                        }
                        else {
                            var result = {
                                status: httpRequest_1.status.toString(),
                                statusText: httpRequest_1.responseText,
                                url: service_1
                            };
                            result.name = 'onFailure';
                            if (!isNullOrUndefined(spellchecker.documentHelper)) {
                                spellchecker.documentHelper.owner.fireServiceFailure(result);
                            }
                            reject(httpRequest_1.response);
                        }
                    }
                };
            }
        });
    };
    SpellChecker.prototype.setCustomHeaders = function (httpRequest, headers) {
        if (!isNullOrUndefined(headers)) {
            for (var i = 0; i < headers.length; i++) {
                var header = headers[i];
                for (var _i = 0, _a = Object.keys(header); _i < _a.length; _i++) {
                    var key = _a[_i];
                    httpRequest.setRequestHeader(key, header[key]);
                }
            }
        }
    };
    SpellChecker.prototype.checkForHeaderFooterNextError = function () {
        if (!isNullOrUndefined(this.viewer)) {
            var errorWords = this.errorWordCollection;
            var element = void 0;
            if (errorWords.length > 0) {
                for (var i = 0; i < errorWords.length; i++) {
                    var errorElements = errorWords.get(errorWords.keys[i]);
                    if (isNullOrUndefined(errorElements)) {
                        continue;
                    }
                    for (var j = 0; j < errorElements.length; j++) {
                        if (errorElements[j] instanceof ErrorTextElementBox && !errorElements[j].isChangeDetected) {
                            if ((isNullOrUndefined(errorElements[j].start.paragraph) || errorElements[j].start.paragraph.indexInOwner === -1)) {
                                errorElements.splice(j, 1);
                                j--;
                                if (errorElements.length === 0) {
                                    this.errorWordCollection.remove(errorWords.keys[i]);
                                    i--;
                                }
                            }
                            else {
                                if (isNullOrUndefined(element) && errorElements[j].start.paragraph.isInHeaderFooter) {
                                    return { element: errorElements[j], text: errorWords.keys[i] };
                                }
                            }
                        }
                        else if (errorElements[j] instanceof TextElementBox) {
                            if (isNullOrUndefined(errorElements[j].paragraph) || errorElements[j].paragraph.indexInOwner === -1) {
                                errorElements.splice(j, 1);
                                j--;
                                if (errorElements.length === 0) {
                                    this.errorWordCollection.remove(errorWords.keys[i]);
                                    i--;
                                }
                            }
                            else {
                                if (isNullOrUndefined(element) && errorElements[j].line && errorElements[j].line.paragraph && errorElements[j].line.paragraph.isInHeaderFooter) {
                                    var matchResults = this.getMatchedResultsFromElement(errorElements[j]);
                                    var results = matchResults.textResults;
                                    var markIndex = (errorElements[j].isChangeDetected && !isNullOrUndefined(errorElements[j].start)) ? errorElements[j].start.offset : errorElements[j].line.getOffset(errorElements[j], 0);
                                    this.documentHelper.owner.searchModule.textSearch.updateMatchedTextLocation(matchResults.matches, results, matchResults.elementInfo, 0, errorElements[j], false, null, markIndex);
                                    for (var i_2 = 0; i_2 < results.length; i_2++) {
                                        var errorElement = this.createErrorElementWithInfo(results.innerList[i_2], errorElements[j]);
                                        element = { element: errorElement, text: errorElement.text };
                                    }
                                }
                            }
                        }
                    }
                }
            }
            else {
                this.documentHelper.clearSelectionHighlight();
            }
            return element;
        }
        return undefined;
    };
    /**
     * Method to check for next error
     *
     * @private
     * @returns {void}
     */
    SpellChecker.prototype.checkForNextError = function () {
        if (!isNullOrUndefined(this.viewer)) {
            if (this.errorWordCollection.length > 0) {
                var start = this.documentHelper.selection.start;
                var isInHeaderFooter = start.currentWidget.paragraph.isInHeaderFooter;
                var element = void 0;
                if (isInHeaderFooter) {
                    element = this.checkForHeaderFooterNextError();
                }
                if (!isInHeaderFooter) {
                    element = this.checkSelectionNextError(start);
                }
                if (isNullOrUndefined(element)) {
                    start = this.documentHelper.selection.getDocumentStart();
                    element = this.checkSelectionNextError(start);
                    if (!isNullOrUndefined(element) && !start.currentWidget.paragraph.isInHeaderFooter && this.documentHelper.owner.enableHeaderAndFooter) {
                        this.documentHelper.selection.closeHeaderFooter();
                    }
                }
                if (isNullOrUndefined(element)) {
                    element = this.checkForHeaderFooterNextError();
                }
                if (!isNullOrUndefined(element)) {
                    if (element.element instanceof ErrorTextElementBox) {
                        this.updateErrorElementTextBox(element.text, element.element);
                    }
                    else if (element.element instanceof TextElementBox) {
                        var errorElement = element.element;
                        var currentText = element.element.text.trim();
                        var matchResults = this.getMatchedResultsFromElement(errorElement, currentText);
                        var results = matchResults.textResults;
                        var markIndex = errorElement.line.getOffset(errorElement, 0);
                        this.documentHelper.owner.searchModule.textSearch.updateMatchedTextLocation(matchResults.matches, results, matchResults.elementInfo, 0, errorElement, false, null, markIndex);
                        for (var i = 0; i < results.length; i++) {
                            var errorTextElement = this.createErrorElementWithInfo(results.innerList[i], errorElement);
                            this.updateErrorElementTextBox(element.text, errorTextElement);
                            this.updateErrorCollection(element.text, errorTextElement);
                            break;
                        }
                    }
                }
            }
            else {
                this.documentHelper.clearSelectionHighlight();
            }
        }
    };
    SpellChecker.prototype.checkSelectionNextError = function (start) {
        var errorWords = this.errorWordCollection;
        var element;
        var nextErrorPosition;
        for (var i = 0; i < errorWords.length; i++) {
            var errorElements = errorWords.get(errorWords.keys[i]);
            if (isNullOrUndefined(errorElements)) {
                continue;
            }
            for (var j = 0; j < errorElements.length; j++) {
                var errorElement = errorElements[j];
                var elementStart = void 0;
                if (errorElement instanceof ErrorTextElementBox || errorElement instanceof TextElementBox) {
                    if (errorElement instanceof ErrorTextElementBox) {
                        elementStart = errorElement.start;
                        if ((isNullOrUndefined(errorElement.start.paragraph) || errorElement.start.paragraph.indexInOwner === -1) || errorElement.indexInOwner === -1) {
                            errorElements.splice(j, 1);
                            j--;
                            if (errorElements.length === 0) {
                                this.errorWordCollection.remove(errorWords.keys[i]);
                                i--;
                            }
                            continue;
                        }
                        if (errorElement.start.paragraph.isInHeaderFooter) {
                            continue;
                        }
                    }
                    else {
                        if (isNullOrUndefined(errorElement.paragraph) || errorElement.paragraph.indexInOwner === -1 || errorElement.indexInOwner === -1) {
                            errorElements.splice(j, 1);
                            j--;
                            if (errorElements.length === 0) {
                                this.errorWordCollection.remove(errorWords.keys[i]);
                                i--;
                            }
                            continue;
                        }
                        if (errorElement.paragraph.isInHeaderFooter) {
                            continue;
                        }
                    }
                    if (isNullOrUndefined(elementStart)) {
                        var offset = errorElement.line.getOffset(errorElement, 1);
                        elementStart = new TextPosition(this.documentHelper.owner);
                        elementStart.setPositionParagraph(errorElement.line, offset);
                    }
                    if (elementStart) {
                        var isExistBefore = start.isExistBefore(elementStart) || start.isAtSamePosition(elementStart);
                        if (isNullOrUndefined(nextErrorPosition)) {
                            if (isExistBefore) {
                                element = { element: errorElement, text: errorWords.keys[i] };
                                nextErrorPosition = elementStart;
                            }
                        }
                        else {
                            var isExistAfter = nextErrorPosition.isExistAfter(elementStart);
                            if (isExistBefore && isExistAfter) {
                                element = { element: errorElement, text: errorWords.keys[i] };
                                nextErrorPosition = elementStart;
                            }
                        }
                    }
                }
            }
        }
        return element;
    };
    /**
     * Method to create error element with matched results
     *
     * @param {TextSearchResult} result
     * @param {ElementBox} errorElement
     * @private
     */
    SpellChecker.prototype.createErrorElementWithInfo = function (result, errorElement) {
        var element = new ErrorTextElementBox();
        var isUpdated = false;
        var text = this.documentHelper.selection.getTextInternal(result.start, result.end, false);
        if (errorElement instanceof ErrorTextElementBox && (isNullOrUndefined(result.start) || isNullOrUndefined(result.end) || isNullOrUndefined(text))) {
            element.text = errorElement.text;
            var line = errorElement.line;
            for (var i = 0; i < line.children.length; i++) {
                if (line.children[i] instanceof TextElementBox) {
                    var text_1 = line.children[i].text;
                    var exactText = errorElement.text;
                    if (text_1.indexOf(exactText) !== -1) {
                        errorElement.start.offset = text_1.indexOf(exactText);
                        errorElement.end.offset = errorElement.start.offset + exactText.length;
                        element.start = errorElement.start;
                        element.end = errorElement.end;
                        element.start.currentWidget = errorElement.line;
                        element.end.currentWidget = errorElement.line;
                        isUpdated = true;
                        break;
                    }
                }
            }
            if (!isUpdated) {
                element.text = errorElement.text;
                element.start = errorElement.start;
                element.end = errorElement.end;
                isUpdated = true;
            }
        }
        if (!isUpdated) {
            element.text = text;
            element.start = result.start;
            element.end = result.end;
        }
        element.height = errorElement.height;
        element.canTrigger = errorElement.canTrigger;
        element.characterFormat.copyFormat(errorElement.characterFormat);
        // element.width = this.documentHelper.textHelper.getWidth(element.text, errorElement.characterFormat, (errorElement as TextElementBox).scriptType);
        element.width = Math.abs(element.start.location.x - element.end.location.x);
        return element;
    };
    /**
     * Method to get matched results from element box
     *
     * @private
     * @param {ElementBox} errorElement - Specifies the error element box.
     * @param {string} currentText - Specifies the current text
     * @returns {MatchResults} - Returns match results info.
     */
    SpellChecker.prototype.getMatchedResultsFromElement = function (errorElement, currentText) {
        var line = errorElement.line;
        var searchText = (isNullOrUndefined(currentText)) ? errorElement.text : currentText;
        var pattern = this.documentHelper.owner.searchModule.textSearch.stringToRegex(searchText, 'CaseSensitive');
        this.textSearchResults.clearResults();
        var results = this.textSearchResults;
        var textLineInfo = this.documentHelper.owner.searchModule.textSearch.getElementInfo(line.children[0], 0, false, pattern, undefined, undefined, undefined, undefined, true);
        var text = textLineInfo.fullText;
        var matches = [];
        var spans = textLineInfo.elementsWithOffset;
        var matchObject;
        // Guard: skip matching if the search text is empty to prevent infinite loop
        if (isNullOrUndefined(searchText) || searchText.length === 0) {
            return { 'matches': matches, 'elementInfo': spans, 'textResults': results };
        }
        // eslint-disable  no-cond-assign
        while (!isNullOrUndefined(matchObject = pattern.exec(text))) {
            // Prevent infinite loop on zero-length matches by manually advancing lastIndex
            if (matchObject[0].length === 0) {
                pattern.lastIndex++;
                continue;
            }
            var hasWhitespace = /\s/.test(errorElement.text);
            if (this.isChangeAll && !(errorElement instanceof ErrorTextElementBox) && !hasWhitespace) {
                matchObject.index = spans.get(errorElement);
            }
            matches.push(matchObject);
        }
        return { 'matches': matches, 'elementInfo': spans, 'textResults': results };
    };
    /**
     * Method to update error element information
     *
     * @private
     * @param {string} error - Specifies the error word.
     * @param {ErrorTextElementBox} errorElement - Specifies the error element box.
     * @returns {void}
     */
    SpellChecker.prototype.updateErrorElementTextBox = function (error, errorElement) {
        var element = errorElement;
        this.documentHelper.clearSelectionHighlight();
        this.documentHelper.selection.start = element.start.clone();
        this.documentHelper.selection.end = element.end.clone();
        this.documentHelper.selection.highlight(errorElement.start.paragraph, errorElement.start, errorElement.end);
        this.documentHelper.owner.spellCheckDialogModule.updateSuggestionDialog(error, element);
    };
    /**
     * Method to retrieve space information in a text
     *
     * @private
     * @param {string} text - Specifies the text
     * @param {WCharacterFormat} characterFormat - Specifies the character format.
     * @returns {SpecialCharacterInfo} - Returs special character info.
     */
    SpellChecker.prototype.getWhiteSpaceCharacterInfo = function (elementBox) {
        var text = elementBox.text;
        var characterFormat = elementBox.characterFormat;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        var matchedText = [];
        var width = 0;
        var length = 0;
        matchedText = text.match(/[\s]+/);
        if (!isNullOrUndefined(matchedText) && matchedText.length > 0) {
            for (var i = 0; i < matchedText.length; i++) {
                width += this.documentHelper.textHelper.getWidth(matchedText[i], characterFormat, elementBox.scriptType);
                length += matchedText[i].length;
            }
        }
        return { 'width': width, 'wordLength': length, 'isBeginning': (!isNullOrUndefined(matchedText) && matchedText.index === 0) };
    };
    /**
     * Retrieve Special character info
     *
     * @private
     * @param {string} text - Specifies the text
     * @param {WCharacterFormat} characterFormat - Specifies the character format.
     * @returns {SpecialCharacterInfo} - Returs special character info.
     */
    SpellChecker.prototype.getSpecialCharactersInfo = function (elementBox) {
        var text = elementBox.text;
        var characterFormat = elementBox.characterFormat;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        var matchedText = [];
        var beginingwidth = 0;
        var endWidth = 0;
        var length = 0;
        matchedText = text.match(/^[\#\@\!\~\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\:\;\"\'\,\<\.\>\/\?\`]*/);
        for (var i = 0; i < matchedText.length; i++) {
            if (!isNullOrUndefined(matchedText[i]) && matchedText[i].length > 0) {
                beginingwidth = this.documentHelper.textHelper.getWidth(matchedText[i], characterFormat, elementBox.scriptType);
            }
            length = matchedText.length;
        }
        matchedText = text.match(/[\#\@\!\~\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\:\;\"\'\,\<\.\>\/\?\`]*$/);
        for (var i = 0; i < matchedText.length; i++) {
            if (!isNullOrUndefined(matchedText[i]) && matchedText[i].length > 0) {
                endWidth = this.documentHelper.textHelper.getWidth(matchedText[i], characterFormat, elementBox.scriptType);
            }
            length = matchedText.length;
        }
        return { 'beginningWidth': beginingwidth, 'endWidth': endWidth, 'wordLength': length };
    };
    /**
     * Method to retrieve next available combined element
     *
     * @private
     * @param {ElementBox} element - Specified the element.
     * @returns {ElementBox} - Returns combined element.
     */
    SpellChecker.prototype.getCombinedElement = function (element) {
        var prevElement = element;
        while (!isNullOrUndefined(element) && element instanceof TextElementBox && element.istextCombined) {
            prevElement = element;
            element = element.previousElement;
        }
        return prevElement;
    };
    SpellChecker.prototype.checkCombinedElementsBeIgnored = function (elements, exactText) {
        exactText = this.manageSpecialCharacters(exactText, undefined, true);
        for (var i = 0; i < elements.length; i++) {
            if (elements[i].ignoreOnceItems.indexOf(exactText) !== -1) {
                return true;
            }
        }
        return false;
    };
    /**
     * Method to update error collection
     *
     * @private
     * @param {TextElementBox} currentElement - Specifies current element.
     * @param {TextElementBox} splittedElement - Specifies splitted element.
     * @returns {void}
     */
    SpellChecker.prototype.updateSplittedElementError = function (currentElement, splittedElement) {
        var errorCount = currentElement.errorCollection.length;
        if (errorCount > 0) {
            var errorCollection = [];
            for (var i = 0; i < errorCount; i++) {
                errorCollection.push(currentElement.errorCollection[i]);
            }
            for (var i = 0; i < errorCount; i++) {
                if (currentElement.text.indexOf(errorCollection[i].text) === -1) {
                    var index = currentElement.errorCollection.indexOf(errorCollection[i]);
                    splittedElement.isChangeDetected = true;
                    if (splittedElement.text.indexOf(errorCollection[i].text) !== -1) {
                        splittedElement.errorCollection.push(errorCollection[i]);
                    }
                    currentElement.errorCollection.splice(index, 1);
                }
            }
        }
    };
    /**
     * Method to update error collection
     *
     * @private
     * @param {TextElementBox} currentElement - Specifies current element.
     * @param {TextElementBox} splittedElement - Specifies splitted element.
     * @returns {void}
     */
    SpellChecker.prototype.updateErrorCollectionForSplitElement = function (currentElement, splittedElement, splittedstartIndex) {
        var errorCount = (currentElement && currentElement.errorCollection) ? currentElement.errorCollection.length : 0;
        if (errorCount > 0) {
            var errorCollection = [];
            var splittedEndIndex = splittedstartIndex + (splittedElement.text.length);
            var currentElementIndex = currentElement.line.getOffset(currentElement, 0);
            for (var i = 0; i < errorCount; i++) {
                errorCollection.push(currentElement.errorCollection[i]);
            }
            for (var i = 0; i < errorCount; i++) {
                if (splittedElement && splittedElement.text.indexOf(errorCollection[i].text) !== -1 &&
                    errorCollection[i].start.offset >= currentElementIndex + splittedstartIndex && errorCollection[i].end.offset <= currentElementIndex + splittedEndIndex) {
                    splittedElement.errorCollection.push(errorCollection[i]);
                    var position = currentElement.errorCollection.indexOf(errorCollection[i]);
                    if (position >= 0) {
                        currentElement.errorCollection.splice(position, 1);
                    }
                }
            }
        }
    };
    /**
     * @private
     * @param {Page} page - Specifies the page.
     * @returns {string} - Returns page content.
     */
    SpellChecker.prototype.getPageContent = function (page) {
        var content = '';
        if (this.documentHelper.owner.sfdtExportModule) {
            var sfdtExport = this.documentHelper.owner.sfdtExportModule;
            var index = sfdtExport.keywordIndex;
            sfdtExport.keywordIndex = 0;
            sfdtExport.Initialize();
            var document_1 = sfdtExport.writePage(page, true);
            sfdtExport.keywordIndex = index;
            sfdtExport.blocks = [];
            if (this.documentHelper.owner.textExportModule) {
                var textExport = this.documentHelper.owner.textExportModule;
                textExport.pageContent = '';
                textExport.setDocument(document_1);
                textExport.writeInternal();
                content = textExport.pageContent;
            }
        }
        return content;
    };
    /**
     * @private
     * @param {any[]} spelledWords - Specifies spelledWords
     * @returns {void}
     */
    SpellChecker.prototype.updateUniqueWords = function (spelledWords) {
        this.getUniqueWordsFromLocalStorage();
        var totalCount = spelledWords.length + this.uniqueSpelledWordsCount;
        if (totalCount <= this.uniqueWordsCount) {
            for (var i = 0; i < spelledWords.length; i++) {
                this.checkForUniqueWords(spelledWords[i]);
            }
        }
        this.addUniqueWordsToLocalStorage();
    };
    SpellChecker.prototype.updateUniqueWord = function (spelledWords) {
        this.uniqueSpelledWords = this.uniqueSpelledWords || {};
        var totalCount = spelledWords.length + this.uniqueSpelledWordsCount;
        if (totalCount <= this.uniqueWordsCount) {
            for (var i = 0; i < spelledWords.length; i++) {
                this.checkForUniqueWords(spelledWords[i]);
            }
        }
    };
    /**
     * @private
     * Get the item from local storage and assign it to uniqueSpelledWords.
     * @returns {void}
     */
    SpellChecker.prototype.getUniqueWordsFromLocalStorage = function () {
        if (!isNullOrUndefined(localStorage.getItem(this.uniqueKey))) {
            var spellData = JSON.parse(localStorage.getItem(this.uniqueKey));
            if (Object.keys(this.uniqueSpelledWords).length > 0 && Object.keys(spellData).length === 0) {
                spellData = this.uniqueSpelledWords;
            }
            this.uniqueSpelledWords = spellData;
        }
        this.uniqueSpelledWords = this.uniqueSpelledWords || {};
        this.uniqueSpelledWordsCount = Object.keys(this.uniqueSpelledWords).length;
    };
    /**
     * @private
     * set the uniqueSpelledWords to local storage.
     * @returns {void}
     */
    SpellChecker.prototype.addUniqueWordsToLocalStorage = function () {
        try {
            localStorage.setItem(this.uniqueKey, JSON.stringify(this.uniqueSpelledWords));
        }
        catch (e) {
            if (e.name === 'QuotaExceededError') {
                this.clearCache();
                localStorage.setItem(this.uniqueKey, JSON.stringify(this.uniqueSpelledWords));
            }
        }
        this.uniqueSpelledWords = {};
        this.uniqueSpelledWordsCount = 0;
    };
    SpellChecker.prototype.checkForUniqueWords = function (spellData) {
        var identityMatched = this.uniqueSpelledWords[spellData.Text];
        if (!identityMatched) {
            this.uniqueSpelledWords[spellData.Text] = spellData.HasSpellError;
            this.uniqueSpelledWordsCount++;
        }
    };
    /**
     * Method to clear cached words for spell check
     *
     * @returns {void}
     */
    SpellChecker.prototype.clearCache = function () {
        if (!isNullOrUndefined(localStorage.getItem(this.uniqueKey))) {
            localStorage.removeItem(this.uniqueKey);
        }
    };
    SpellChecker.prototype.createGuid = function () {
        var dateTime = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
            var randNo = (dateTime + Math.random() * 16) % 16 | 0;
            dateTime = Math.floor(dateTime / 16);
            return (char === 'x' ? randNo : (randNo & 0x3 | 0x8)).toString(16);
        });
        return uuid;
    };
    /**
     * Check spelling in page data
     *
     * @private
     * @param {string} wordToCheck - Specifies wordToCheck
     * @param {TextElementBox} elementBox - Specifies elementBox
     * @returns {WordSpellInfo} - Retruns WordSpellInfo
     */
    SpellChecker.prototype.checkSpellingInPageInfo = function (wordToCheck, elementBox) {
        var hasError = false;
        var elementPresent = false;
        /* eslint-disable @typescript-eslint/no-explicit-any */
        var uniqueWords = this.uniqueSpelledWords || {};
        if (!isNullOrUndefined(uniqueWords)) {
            if (Object.prototype.hasOwnProperty.call(uniqueWords, wordToCheck)) {
                return { hasSpellError: uniqueWords[wordToCheck], isElementPresent: true };
            }
        }
        if (elementBox && !Object.prototype.hasOwnProperty.call(uniqueWords, wordToCheck) && elementBox.width === 0 && elementBox.height === 0) {
            return { hasSpellError: hasError, isElementPresent: true };
        }
        return { hasSpellError: hasError, isElementPresent: elementPresent };
    };
    /**
     * @private
     * @returns {void}
     */
    SpellChecker.prototype.resetSpellCheckState = function () {
        this.documentHelper.cachedPages = [];
        if (!isNullOrUndefined(this.errorWordCollection)) {
            this.errorWordCollection.clear();
        }
        if (!isNullOrUndefined(this.uniqueWordsCollection)) {
            this.uniqueWordsCollection.clear();
        }
        this.ignoreAllItems = [];
        this.uniqueSpelledWords = {};
        this.errorSuggestions = new Dictionary();
        this.handleErrorElements = [];
        this.pageCacheIndex = [];
        if (!isNullOrUndefined(localStorage.getItem(this.uniqueKey))) {
            localStorage.removeItem(this.uniqueKey);
        }
    };
    /**
     *
     * @private
     */
    SpellChecker.prototype.triggerErrorForNonRenderPages = function () {
        var _this = this;
        if (this.documentHelper.render) {
            setTimeout(function () {
                var _loop_1 = function (i) {
                    var page = _this.documentHelper.pages[i];
                    if (_this.pageCacheIndex.indexOf(page.index) === -1) {
                        if (_this.documentHelper.cachedPages.indexOf(page.index) === -1) {
                            _this.documentHelper.cachedPages.push(page.index);
                        }
                        _this.pageCacheIndex.push(page.index);
                        var content = _this.getPageContent(page);
                        if (content.trim().length > 0) {
                            _this.updateUniqueWords(HelperMethods.getSpellCheckData(content));
                            /* eslint-disable @typescript-eslint/no-explicit-any */
                            _this.callSpellChecker(_this.languageID, content, true, false, false, true).then(function (data) {
                                /* eslint-disable @typescript-eslint/no-explicit-any */
                                var jsonObject = JSON.parse(data);
                                if (!isNullOrUndefined(_this.documentHelper.owner)) {
                                    _this.updateUniqueWords(jsonObject.SpellCollection);
                                    if (!isNullOrUndefined(_this.documentHelper)) {
                                        _this.documentHelper.triggerElementsOnLoading = true;
                                        _this.documentHelper.triggerSpellCheck = true;
                                        _this.documentHelper.triggerElementsOnLoading = true;
                                        _this.documentHelper.render.skipRenderWavyLine = true;
                                        _this.triggerPage(page);
                                        _this.documentHelper.render.skipRenderWavyLine = false;
                                        _this.documentHelper.triggerSpellCheck = false;
                                        _this.documentHelper.triggerElementsOnLoading = false;
                                    }
                                }
                            })
                                .catch();
                            {
                                if (!isNullOrUndefined(_this.documentHelper.render)) {
                                    _this.documentHelper.render.skipRenderWavyLine = false;
                                }
                            }
                        }
                    }
                };
                for (var i = 0; i < _this.documentHelper.pages.length; i++) {
                    _loop_1(i);
                }
            }, 0);
        }
    };
    SpellChecker.prototype.triggerPage = function (page) {
        this.getUniqueWordsFromLocalStorage();
        this.triggerWidgets(page);
        this.addUniqueWordsToLocalStorage();
    };
    SpellChecker.prototype.triggerParagraphWidget = function (paragarph) {
        for (var i = 0; i < paragarph.childWidgets.length; i++) {
            var lineWidget = paragarph.childWidgets[i];
            for (var j = 0; j < lineWidget.children.length; j++) {
                if (lineWidget.children[j] instanceof TextElementBox && lineWidget.children[j].width !== 0 && lineWidget.children[j].height !== 0) {
                    this.documentHelper.render.triggerSpellChecker(lineWidget.children[j], undefined, false, 0, 0, 0, undefined);
                }
            }
        }
    };
    SpellChecker.prototype.triggerTableWidget = function (table) {
        for (var i = 0; i < table.childWidgets.length; i++) {
            var rowWidget = table.childWidgets[i];
            for (var j = 0; j < rowWidget.childWidgets.length; j++) {
                var cellWidget = rowWidget.childWidgets[j];
                for (var k = 0; k < cellWidget.childWidgets.length; k++) {
                    if (cellWidget.childWidgets[k] instanceof TableWidget) {
                        this.triggerTableWidget(cellWidget.childWidgets[k]);
                    }
                    else if (cellWidget.childWidgets[k] instanceof ParagraphWidget) {
                        this.triggerParagraphWidget(cellWidget.childWidgets[k]);
                    }
                }
            }
        }
    };
    SpellChecker.prototype.triggerWidgets = function (page) {
        if (page.headerWidget) {
            this.triggerHFWidgets(page, page.headerWidgetIn);
        }
        if (page.footerWidget) {
            this.triggerHFWidgets(page, page.footerWidgetIn);
        }
        /* eslint-disable */
        for (var i = 0; i < page.bodyWidgets.length; i++) {
            if (!isNullOrUndefined(page.bodyWidgets[i].floatingElements)) {
                this.triggerFloatingItems(page, page.bodyWidgets[i].floatingElements, 'Behind');
            }
        }
        /* eslint-enable */
        for (var i = 0; i < page.bodyWidgets.length; i++) {
            this.trigger(page, page.bodyWidgets[parseInt(i.toString(), 10)]);
            if (page.footnoteWidget && this.documentHelper.owner.layoutType === 'Pages') {
                this.triggerFootNoteWidget(page, page.footnoteWidget);
            }
        }
        if (page.endnoteWidget && this.documentHelper.owner.layoutType === 'Pages') {
            this.triggerFootNoteWidget(page, page.endnoteWidget);
        }
    };
    SpellChecker.prototype.triggerHFWidgets = function (page, widget) {
        this.triggerFloatingItems(page, widget.floatingElements, 'Behind');
        for (var i = 0; i < widget.childWidgets.length; i++) {
            var block = widget.childWidgets[parseInt(i.toString(), 10)];
            this.triggerWidget(block);
        }
        this.triggerFloatingItems(page, widget.floatingElements, 'InFrontOfText');
    };
    SpellChecker.prototype.triggerFloatingItems = function (page, floatingElements, wrappingType) {
        if (!isNullOrUndefined(floatingElements) && floatingElements.length > 0) {
            var overLappedShapeWidgets = new Dictionary();
            /* eslint-disable */
            floatingElements.sort(function (a, b) {
                if (a instanceof TableWidget || b instanceof TableWidget) {
                    return 0;
                }
                else {
                    return a.zOrderPosition - b.zOrderPosition;
                }
            });
            for (var i = 0; i < floatingElements.length; i++) {
                if (floatingElements[i] instanceof TableWidget) {
                    continue;
                }
                var shape = floatingElements[i];
                if ((wrappingType === "Behind" && shape.textWrappingStyle !== "Behind") ||
                    (wrappingType !== "Behind" && shape.textWrappingStyle === "Behind")) {
                    continue;
                }
                if (!this.documentHelper.render.isOverLappedShapeWidget(shape) || overLappedShapeWidgets.containsKey(shape.zOrderPosition)) {
                    if (shape instanceof ShapeElementBox) {
                        this.triggerShapeElementBox(shape, page);
                    }
                    else if (shape instanceof GroupShapeElementBox) {
                        this.triggerGroupShapeElementBox(shape, page);
                    }
                }
                else if (!overLappedShapeWidgets.containsKey(shape.zOrderPosition)) {
                    overLappedShapeWidgets.add(shape.zOrderPosition, shape);
                }
            }
            if (overLappedShapeWidgets.length > 0) {
                var sortedOverLappedShapeWidgets = overLappedShapeWidgets.keys.sort();
                for (var j = 0; j < sortedOverLappedShapeWidgets.length; j++) {
                    var shape = overLappedShapeWidgets.get(sortedOverLappedShapeWidgets[j]);
                    if (shape instanceof ShapeElementBox) {
                        this.triggerShapeElementBox(shape, page);
                    }
                    else if (shape instanceof GroupShapeElementBox) {
                        this.triggerGroupShapeElementBox(shape, page);
                    }
                }
            }
        }
    };
    SpellChecker.prototype.triggerShapeElementBox = function (shape, page) {
        if (shape.isHorizontalRule) {
            return;
        }
        var blocks = shape.textFrame.childWidgets;
        for (var i = 0; i < blocks.length; i++) {
            this.triggerWidget(blocks[i]);
        }
    };
    SpellChecker.prototype.triggerWidget = function (widget) {
        if (widget instanceof ParagraphWidget) {
            this.triggerParagraphWidget(widget);
        }
        else {
            this.triggerTableWidget(widget);
        }
    };
    SpellChecker.prototype.trigger = function (page, bodyWidget) {
        for (var i = 0; i < bodyWidget.childWidgets.length; i++) {
            var widget = bodyWidget.childWidgets[parseInt(i.toString(), 10)];
            this.triggerWidget(widget);
        }
        for (var i = 0; i < page.bodyWidgets.length; i++) {
            if (!isNullOrUndefined(page.bodyWidgets[i].floatingElements)) {
                this.triggerFloatingItems(page, page.bodyWidgets[i].floatingElements, 'InFrontOfText');
            }
        }
    };
    SpellChecker.prototype.triggerGroupShapeElementBox = function (groupShape, page) {
        for (var i = 0; i < groupShape.childWidgets.length; i++) {
            var shape = groupShape.childWidgets[i];
            if (shape instanceof GroupShapeElementBox) {
                this.triggerGroupShapeElementBox(shape, page);
            }
            else if (shape instanceof ShapeElementBox) {
                this.triggerShapeElementBox(shape, page);
            }
        }
    };
    SpellChecker.prototype.triggerFootNoteWidget = function (page, footnote) {
        for (var i = 0; i < footnote.bodyWidgets.length; i++) {
            var bodyWidget = footnote.bodyWidgets[i];
            for (var j = 0; j < bodyWidget.childWidgets.length; j++) {
                var widget = bodyWidget.childWidgets[j];
                this.triggerWidget(widget);
            }
        }
    };
    /**
     * @private
     * @returns {void}
     */
    SpellChecker.prototype.destroy = function () {
        this.errorWordCollection = undefined;
        this.ignoreAllItems = undefined;
        this.errorSuggestions = undefined;
        this.uniqueWordsCollection = undefined;
        this.uniqueSpelledWords = {};
        this.textSearchResults = undefined;
        if (!isNullOrUndefined(localStorage.getItem(this.uniqueKey))) {
            localStorage.removeItem(this.uniqueKey);
        }
        this.documentHelper = undefined;
        this.handleErrorElements = [];
        this.pageCacheIndex = [];
    };
    return SpellChecker;
}());
export { SpellChecker };
